// ===== Packages =====

import {
    getFunctions,
    httpsCallable,
}                                   from 'firebase/functions';

// ===== Services =====

import runCallableWithRetry, {
    ICallableRetryConfig,
}                                   from './runCallableWithRetry';

const recordPostView = async ({
    test,
    postId,
    requestId,
    chapterId,
    sectionId,
    retry,
}: {
    test: boolean,
    postId: string,
    requestId: string,
    chapterId?: string,
    sectionId?: string,
    retry?: ICallableRetryConfig,
}): Promise<boolean> => {
    const functions = getFunctions();
    const handleRecordPostView = httpsCallable<
        Record<string, boolean | string | undefined>,
        boolean
    >(
        functions,
        'recordPostView',
    );
    const executeRecord = async (): Promise<boolean> => {
        const result = await handleRecordPostView({
            test,
            postId,
            requestId,
            chapterId,
            sectionId,
        });
        return result.data as boolean;
    };

    if (retry) {
        return runCallableWithRetry<boolean>(
            executeRecord,
            retry,
        );
    }

    return executeRecord();
};

export default recordPostView;
